import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

export const getInterests = async ({ query }) => {
  const response = await axios.post('/api/demonstrative/faq', null, { params: { query } })
  return response.data || []
}

export const useSearchInterestsOnDemonstrativeFaq = () => useMutation(getInterests)